// src/Form.js
import './form.css'

export default function Form() {
    return (
        <form
            method='POST'
            name='waitinglistForm'
            className='waitinglistForm'>
            <input
                type='hidden'
                name='form-name'
                value='waitinglistForm' />
            {/* <input
                type='text'
                name='name'
                placeholder='Enter your name' /> */}

            <input
                type='email'
                name='email'
                placeholder='Enter your email' />
            {/* 
            <textarea
                name='message'
                placeholder='Messaage'></textarea> */}

            <button type='submit' className="btn main-button-red-submit">Submit</button>

        </form>
    )
}